import { render, staticRenderFns } from "./Ajuda.vue?vue&type=template&id=fb4a95a4"
import script from "./Ajuda.vue?vue&type=script&lang=js"
export * from "./Ajuda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports